import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { TenderType } from 'src/common/enumerations/tender-type';
import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';
import { store } from 'src/common/redux/configure-store';

export const getIsEwicTenderInTbr = (): boolean => {
  const tender: IElectronicJournalRecord | undefined = store
    .getState()
    .tbr.tbrItemsList.find(
      item =>
        item.Type === EJRecordTypes.Tender &&
        item.TenderType?.toUpperCase() === TenderType.Ewic.toUpperCase(),
    );
  if (tender) {
    return true;
  }
  return false;
};
